import initBasket from './modules/Basket';

document.addEventListener('DOMContentLoaded', () => {
  initBasket();
});

// (function ($) {
//   $('body').on('click', function (e) {
//     const isBasketModalClose = $(e.target).parents('.basket-popup-wrap').length;
//     if (!isBasketModalClose) {
//       $('.popup-basket').removeClass('open');
//     }
//   })
//
//   $('.js-basket').each(function () {
//     const $btn = $(this);
//     const popup = $btn.next('.popup-basket');
//     $btn.on('click', function () {
//       $('.popup-basket').each(function () {
//         $(this).removeClass('open');
//       })
//       popup.toggleClass('open');
//     })
//     console.log(popup.find('.popup-basket__close'));
//     popup.find('.popup-basket__close').on('click', function () {
//       console.log($(this));
//       popup.removeClass('open');
//     })
//   })
// })(jQuery);
